// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/settings/organization-positions/archive',
        component: () =>
            import('@/pages/[organisation]/settings/organization-positions/archive.vue'),
        name: 'settings.organization-positions.archived-organization-positions',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.position.update-organization-position',
        },
    },
    {
        path: '/:organisation/settings/organization-positions/archive/:id',
        component: () =>
            import('@/pages/[organisation]/settings/organization-positions/archive/[id].vue'),
        name: 'settings.organization-positions.view-archived-organization-position',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.position.update-organization-position',
        },
    },
    {
        path: '/:organisation/settings/organization-positions',
        component: () =>
            import('@/pages/[organisation]/settings/organization-positions.vue'),
        name: 'settings.organization-positions.search-organization-positions',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.position.view-organization-positions',
        },
    },
    {
        path: '/:organisation/settings/organization-positions/new',
        component: () =>
            import('@/pages/[organisation]/settings/organization-positions/new.vue'),
        name: 'settings.organization-positions.create-organization-position',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.position.create-organization-position',
        },
    },
    {
        path: '/:organisation/settings/organization-positions/:id',
        component: () =>
            import('@/pages/[organisation]/settings/organization-positions/[id].vue'),
        name: 'settings.organization-positions.view-organization-position',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.position.view-organization-positions',
        },
    },
    {
        path: '/:organisation/settings/organization-positions/:id/edit',
        component: () =>
            import('@/pages/[organisation]/settings/organization-positions/[id]/edit.vue'),
        name: 'settings.organization-positions.update-organization-position',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.position.update-organization-position',
        },
    },
];
